<template>

    <div class="add_contacts_container">

        <div class="columns">
            <div class="column add_contact_left_column">
                <div class="left_column_inside">
                    <div class="add_contact_slot_container" v-if="(currentChoice == 'form')">
                        <slot name="headSlot"/>
                    </div>

                    <AddContactsForm v-if="(currentChoice == 'form')"
                        :contactLabel="contactLabel"
                        @choiceClicked="handleChoice"
                        @contactAdded="addContactToList"
                        @backClicked="backToChoice" />

                    <AddContactsCsv v-if="(currentChoice == 'csv')"
                        :contactLabel="contactLabel"
                        @choiceClicked="handleChoice"
                        @addCsvContactsToList="addCsvContactsToList"
                        @backClicked="backToChoice" />

                    <AddContactsUploadFiles v-if="(currentChoice == 'uploadFile')"
                        @fileUploaded="handleUploadedFile" />

                </div>

            </div>
            <div class="column hidden_x right_column_contact_list">

                <addContactsList :contactList='contactList'
                    :contactLabel="contactLabel"
                    :clickUploadEnabled="clickUploadEnabled"
                    :allowFileUpload="allowFileUpload"
                    @openFileUpload="openFileUpload"
                    @contactRemoved="removeContactFromList"
                    @removeFileItemFromContact="removeFileItemFromContact"/>
            </div>

        </div>

    </div>

</template>


<script>
import AddContactsChoice from './addContactsChoice'
import AddContactsList from './addContactsList'
import AddContactsForm from './addContactsForm'
import AddContactsCsv from './addContactsCsv'
import AddContactsUploadFiles from './addContactsUploadFiles'



export default {
    name: 'AddContacts',
    props: {
        contactLabel: {
            type: String,
            default: 'contact'
        },
        allowFileUpload: {
            type: Boolean,
            default: false
        }
    },
    components: {
        AddContactsChoice,
        AddContactsList,
        AddContactsForm,
        AddContactsCsv,
        AddContactsUploadFiles
    },
    data(){
        return {
            currentChoice: 'form',
            contactList: [],
            beforeUploadChoice: null,
            ContactFileUpload: null,
            ContactFileUploadIndex: null
        }
    },
    computed: {
        clickUploadEnabled(){
            return (this.beforeUploadChoice == null)
        }
    },
    methods: {
        handleChoice(choice){
            this.currentChoice = choice
        },
        removeContactFromList(index){
            this.contactList.splice(index, 1);
            this.$emit('contactListModified', this.contactList)
        },
        addContactToList(contact){
            this.contactList.push(contact);
            this.$emit('contactListModified', this.contactList)
        },
        addCsvContactsToList(csvList){
            csvList.forEach( (contact) => {
                this.contactList.push(contact)
            })
            this.$emit('contactListModified', this.contactList)
        },
        backToChoice(){
            this.currentChoice = 'form'
        },
        resetAllStates(){
            this.currentChoice = 'form'
            this.contactList = []
        },
        openFileUpload(contact, index){
            this.beforeUploadChoice = this.currentChoice
            this.currentChoice = 'uploadFile'
            this.ContactFileUpload = contact
            this.ContactFileUploadIndex = index
        },
        handleUploadedFile(fileList){
            const evalFiles = JSON.parse(JSON.stringify(this.ContactFileUpload.docs_ids))
            const files = this._.union(evalFiles, fileList)
            this.ContactFileUpload.docs_ids = files
            this.$set(this.contactList, this.ContactFileUploadIndex, this.ContactFileUpload)
            this.$emit('contactListModified', this.contactList)
            this.currentChoice = this.beforeUploadChoice
            this.beforeUploadChoice = null
        },
        removeFileItemFromContact(contact, index, file, file_index){
            const contactListTemp = JSON.parse(JSON.stringify(this.contactList))
            contactListTemp[index].docs_ids.splice(file_index, 1)
            this.$emit('contactListModified', contactListTemp)
            this.contactList = contactListTemp
        }
    }
}

</script>

<style lang="scss" >
.hidden_x{
    overflow-x: hidden;
    background: $white-ter;
}
.add_contacts_container{
    min-height: 448px;
}
.add_contact_left_column{
    min-height: 448px;
    // border-right: 1px solid $grey-lighter;
}
.left_column_inside{
    padding-right: 30px;
}
.right_column_contact_list{
    margin-right: 0.75rem!important;
}

</style>